import React, { useState } from "react";
import styled from "@emotion/styled";
import ImageTitle from "../components/ImageTitle";
import StatesImage from "../assets/images/CNC-States.jpg";
import { ToggleButton, ToggleButtonGroup, Stack, Box, Button } from "@mui/material";
import sedesInfo from "./sedesInfo.json";
import CarruselCECAP from "../components/CarruselCECAP";
import StateCatalog from "../components/StateCatalog";
import ContactImg from "../assets/images/Cards/Card-Personas.jpg";
import { IoIosMail } from "react-icons/io";
import { BsTelephoneInboundFill } from "react-icons/bs";
import { motion, AnimatePresence } from "framer-motion";
import logoCECAP from "../assets/logos/logo_cecap.png";

const States = () => {
  const [estadoSeleccionado, setEstadoSeleccionado] = useState("Sede Nacional");
  const [mostrarSelector, setMostrarSelector] = useState(false);

  const estadosMexico = [
    "Sede Nacional", "CENCAD", "Aguascalientes", "Baja California", "Baja California Sur", "Campeche",
    "Chiapas", "Chihuahua", "Coahuila", "Colima", "CDMX y EDOMEX", "Durango",
    "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "Michoacán", "Morelos",
    "Nayarit", "Nuevo León", "Oaxaca", "Puebla", "Querétaro", "Quintana Roo",
    "San Luis Potosí", "Sinaloa", "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala",
    "Veracruz", "Yucatán", "Zacatecas"
  ];

  const handleEstadoChange = (event, nuevoEstado) => {
    if (nuevoEstado !== null) {
      setEstadoSeleccionado(nuevoEstado);
    }
  };

  const datosEstado = sedesInfo[estadoSeleccionado] || {};
  const CECAPData = Array.isArray(datosEstado.CECAP) ? datosEstado.CECAP : [];
  const CECAPImgs = Array.isArray(datosEstado.CECAPImg) ? datosEstado.CECAPImg : [];
  const cursos = Array.isArray(datosEstado.cursos) ? datosEstado.cursos : [];
  const cursosImgs = Array.isArray(datosEstado.cursosImg) ? datosEstado.cursosImg : [];

  // Estilos
  const GreenDiv = styled.div`
    background: linear-gradient(0.25turn, #005522, #069640, #005522);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 10;
  `;

  const ContactDiv = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    height: 20%;
  `;

  const Title = styled.p`
    font-family: "League Gothic", serif;
    font-size: 55px;
    color: white;
    margin: 0px;
  `;

  const Descripcion = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: black;
    padding: 20px;
    margin: 0px 50px;
    text-align: justify;
    width: 70%;
    margin: auto;
  `;

  const TitleContact = styled.p`
    font-family: "League Gothic", serif;
    font-size: 40px;
    color: white;
    margin: 0px;
  `;


  const ContactInfoDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width:100%;
    overflow: hidden;
      /* Media query para pantallas pequeñas (por ejemplo, pantallas de menos de 768px) */
  @media (max-width: 710px) {
    flex-direction: column;
  }
  `;

  const IconDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    margin-left: 20px;
    max-height: 200px;
  `;

  const IconText = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: black;
    display: block;
    padding: 20px;
    text-align: justify;
  `;

  const TextDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  
  font-size: clamp(12px, 5vw, 24px); /* Tamaño de fuente flexible */
  background-color: #ededed;
  border-top-right-radius: 25px;
        /* Media query para pantallas pequeñas (por ejemplo, pantallas de menos de 768px) */
  @media (max-width: 710px) {
    flex-direction: column;
  word-wrap: break-word;  /* Permite que el texto se divida */
  word-break: break-word; /* Rompe palabras largas en caso de desbordamiento */
    }
`;


  const Logo = styled(motion.img)`
    height: 80px;
    margin: 20px;
    margin-top: 40px;
  `;

  const StyledImg = styled.img`
  width: 20%;
  max-height: 600px; /* o lo que tú definas como tope */
  height: auto;
  margin-right: 20px;
  object-fit: cover;

  @media (max-width: 768px) {
    display: none;
  }
`;



  const MotionStack = motion(Stack);

  return (
    <>
      <Box display="flex" justifyContent="center" mt={3}>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#12b854", textTransform: "none" }}
          onClick={() => setMostrarSelector(!mostrarSelector)}
        >
          {mostrarSelector ? "Cerrar Selector" : "Seleccionar Estado"}
        </Button>
      </Box>

      <AnimatePresence>
        {mostrarSelector && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4 }}
            style={{ overflow: "hidden", marginTop: "10px" }}
          >
            <ToggleButtonGroup
              value={estadoSeleccionado}
              exclusive
              onChange={handleEstadoChange}
              aria-label="Selecciona un estado"
              sx={{
                flexWrap: "wrap",
                gap: 0.5,
                mt: "25px",
                justifyContent: "center",
                "& .MuiToggleButton-root": {
                  border: "none",
                  borderLeft: "3px solid transparent",
                  borderRadius: "0",
                  textTransform: "none",
                  padding: "6px 12px",
                  fontSize: "14px",
                  color: "#666",
                  backgroundColor: "transparent",
                  "&.Mui-selected": {
                    borderLeftColor: "#12b854",
                    color: "#000",
                    fontWeight: "bold"
                  },
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.05)"
                  }
                }
              }}
            >
              {estadosMexico.map((estado) => (
                <ToggleButton key={estado} value={estado}>
                  {estado}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </motion.div>
        )}
      </AnimatePresence>

      <ImageTitle
        title={estadoSeleccionado}
        subtitle="COORDINACIÓN ESTATAL DE CAPACITACIÓN"
        image={StatesImage}
      />

      <GreenDiv>
        <Title>CENTROS DE CAPACITACIÓN</Title>
      </GreenDiv>
      <Logo
        src={logoCECAP}
        alt="Logo CECAP"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        viewport={{ once: true }}
      />
      <Descripcion>
        En los Centros de Capacitación <strong>CECAP</strong> son unidades
        formativas donde podrás tener tu formación como Técnico en Urgencias Médicas o realizar tu curso de Actualización.
        Aseguramos una capacitación con calidad y calidez, en cumplimiento con los estándares desde la Coordinación Nacional de Capacitación
      </Descripcion>
            <Descripcion>
        Puedes consultar los CECAP ratificados y operando en el portal de transparencia.
      </Descripcion>
      {//<CarruselCECAP CECAPData={CECAPData} CECAPImgs={CECAPImgs} />
      }

      <GreenDiv>
        <Title>CAPACITACIÓN CONTINUA</Title>
      </GreenDiv>
      <Descripcion>
        Los siguientes cursos de Capacitación Continua han sido validados por el Área Nacional de Formación Académica,
        por lo cual tienen puntos de recertificación asignados según el tabulador establecido.
      </Descripcion>
      <StateCatalog cursos={cursos} cursosImgs={cursosImgs} />


      <GreenDiv>
        <Title>CONTACTO</Title>
      </GreenDiv>

      <ContactDiv>
  <StyledImg
    src={ContactImg}
    alt="Contacto"
    style={{
      width: '20%',  // Ocupa el 15% del ancho
      height: "100vh",
      marginRight:"20px",
      objectFit: 'cover',
    }}
  />
  <MotionStack 
  spacing={2} 
  direction="column" 
  alignItems="left"     
  style={{ margin: 'auto', marginTop: '10px', width: "70%",height:"50%" }}
  initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }} 
  transition={{ duration: 1, ease: "easeOut" }}
  viewport={{ once: true }}
>

<ContactInfoDiv>
    <Box
      sx={{
        width: { xs: '100%', sm: '200px' }, // Mismo ajuste para todos los elementos
        height: { xs: 'auto', sm: '200px' },
        backgroundColor: '#d4af37',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottomLeftRadius: "25px",
        '@media (max-width: 860px)': {
          position: 'relative',
          top: '20px',
          width:'100%',
          height:'30%',
        }
      }}
>
  
  <TitleContact>COORDINADOR RESPONSABLE</TitleContact>
    </Box>
    <TextDiv>
      <IconDiv>
        <IoIosMail color="#12b854" size={20} />
        <IconText><strong>correo electrónico:</strong>&nbsp;{datosEstado.contactoCORDI && datosEstado.contactoCORDI[0] ? datosEstado.contactoCORDI[0] : "No hay información disponible"}</IconText>
      </IconDiv>
      <IconDiv>
        <BsTelephoneInboundFill color="#12b854" size={18} />
        <IconText><strong>teléfono:</strong>&nbsp;{datosEstado.contactoCORDI && datosEstado.contactoCORDI[1] ? datosEstado.contactoCORDI[1] : "No hay información disponible"}</IconText>
      </IconDiv>
    </TextDiv>
  </ContactInfoDiv>

  <ContactInfoDiv>
    <Box
      sx={{
        width: { xs: '100%', sm: '200px' }, // Mismo ajuste para todos los elementos
        height: { xs: 'auto', sm: '200px' },
        backgroundColor: '#aaa4a9',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottomLeftRadius: "25px",
        '@media (max-width: 860px)': {
          position: 'relative',
          top: '20px',
          width:'100%',
          height:'30%',
        }
      }}
>
  
  <TitleContact>CENTROS DE CAPACITACIÓN</TitleContact>
    </Box>
    <TextDiv>
      <IconDiv>
        <IoIosMail color="#12b854" size={20} />
        <IconText><strong>correo electrónico:</strong>&nbsp;{datosEstado.contactoCECAP && datosEstado.contactoCECAP[0] ? datosEstado.contactoCECAP[0] : "No hay información disponible"}</IconText>
      </IconDiv>
      <IconDiv>
        <BsTelephoneInboundFill color="#12b854" size={18} />
        <IconText><strong>teléfono:</strong>&nbsp;{datosEstado.contactoCECAP && datosEstado.contactoCECAP[1] ? datosEstado.contactoCECAP[1] : "No hay información disponible"}</IconText>
      </IconDiv>
    </TextDiv>
  </ContactInfoDiv>

  <ContactInfoDiv>
  <Box
  sx={{
    width: { xs: '100%', sm: '200px' }, // Ajuste en xs y sm
    height: { xs: 'auto', sm: '200px' },
    backgroundColor: '#aaa4a9',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomLeftRadius: '25px',
    // Media Query personalizada para pantallas de máximo 599px
    '@media (max-width: 860px)': {
      position: 'relative',
      top: '20px',
      width:'100%',
      height:'30%',
    }
  }}
>

      <TitleContact>CAPACITACIÓN CONTINUA</TitleContact>
    </Box>
    <TextDiv>
      <IconDiv>
        <IoIosMail color="#12b854" size={20} />
        <IconText><strong>correo electrónico:</strong>&nbsp;{datosEstado.contactoCC && datosEstado.contactoCC[0] ? datosEstado.contactoCC[0] : "No hay información disponible"}</IconText>
      </IconDiv>
      <IconDiv>
        <BsTelephoneInboundFill color="#12b854" size={18} />
        <IconText><strong>teléfono:</strong>&nbsp;{datosEstado.contactoCC && datosEstado.contactoCC[1] ? datosEstado.contactoCC[1] : "No hay información disponible"}</IconText>
      </IconDiv>
    </TextDiv>
  </ContactInfoDiv>

  <ContactInfoDiv>
    <Box
      sx={{
        width: { xs: '100%', sm: '200px' }, 
        height: { xs: 'auto', sm: '200px' },
        backgroundColor: '#aaa4a9',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottomLeftRadius: "25px",        
        '@media (max-width: 860px)': {
          position: 'relative',
          top: '20px',
          width:'100%',
          height:'30%',
        }
      }}
    >
      <TitleContact>CAPACITACIÓN EXTERNA</TitleContact>
    </Box>
    <TextDiv>
      <IconDiv>
        <IoIosMail color="#12b854" size={20} />
        <IconText><strong>correo electrónico:</strong>&nbsp;{datosEstado.contactoCE && datosEstado.contactoCE[0] ? datosEstado.contactoCE[0] : "No hay información disponible"}</IconText>
      </IconDiv>
      <IconDiv>
        <BsTelephoneInboundFill color="#12b854" size={18} />
        <IconText><strong>teléfono:</strong>&nbsp;{datosEstado.contactoCE && datosEstado.contactoCE[1] ? datosEstado.contactoCE[1] : "No hay información disponible"}</IconText>
      </IconDiv>
    </TextDiv>
  </ContactInfoDiv>
</MotionStack>

</ContactDiv>
    </>
  );
};

export default States;
